var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-539.18 -568.86)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDBDB",
    d: "M558.108,610.351c15.4,0,23.822-12.759,23.822-23.822c0-0.363-0.007-0.722-0.023-1.082 c1.633-1.183,3.058-2.659,4.179-4.337c-1.503,0.667-3.116,1.117-4.81,1.318c1.726-1.036,3.054-2.675,3.683-4.631 c-1.62,0.958-3.411,1.658-5.318,2.034c-1.529-1.629-3.702-2.646-6.112-2.646c-4.622,0-8.372,3.75-8.372,8.373 c0,0.658,0.074,1.295,0.217,1.908c-6.961-0.35-13.131-3.683-17.26-8.748c-0.719,1.237-1.134,2.675-1.134,4.21 c0,2.902,1.48,5.467,3.728,6.967c-1.373-0.042-2.666-0.418-3.793-1.046c0,0.035,0,0.068,0,0.106c0,4.055,2.886,7.44,6.718,8.208 c-0.706,0.191-1.444,0.295-2.209,0.295c-0.538,0-1.065-0.053-1.574-0.152c1.065,3.329,4.155,5.749,7.822,5.816 c-2.866,2.245-6.475,3.582-10.4,3.582c-0.674,0-1.341-0.035-1.995-0.113C548.98,608.964,553.378,610.351,558.108,610.351"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.c506d86c9900cec6d8110d1a7dacae7a.svg";
export { ForwardRef as ReactComponent };